module.exports = __webpack_public_path__ + "media/images/success-img/success-d6e4bdd54e705c2fb78e1999965e7e08.png";